import { IdResourceCollectionStore } from './ResourceCollectionStore';
import { ApiToken } from '../ApiModel';
import { ISiteServicesApiClient } from '../SiteServicesApiClient';

export class ApiTokenStore extends IdResourceCollectionStore<ApiToken> {
    constructor(private siteApiClient: ISiteServicesApiClient) {
        super({
            getItems: () => this.fetchTokens(),
        });
    }

    async fetchTokens(): Promise<ApiToken[]> {
        return await this.siteApiClient.getApiTokens();
    }

    async renameToken(id: string, values: { name: string }): Promise<ApiToken> {
        const token = await this.siteApiClient.updateApiToken(id, values.name);
        return this.updateItem(token);
    }

    async createToken(name: string): Promise<ApiToken> {
        const token = await this.siteApiClient.createApiToken(name);
        return this.addItem(token);
    }

    async regenerateToken(id: string): Promise<ApiToken> {
        const token = await this.siteApiClient.regenerateApiToken(id);
        return this.updateItem(token);
    }

    async deleteToken(id: string): Promise<void> {
        await this.siteApiClient.deleteApiToken(id);
        await this.load();
    }
}
